import { texts } from '@/lib/texts';

/**
 * Запасная кнопка «Назад» для вложенных экранов.
 *
 * Внутри Telegram назад ведёт нативная `BackButton` в шапке клиента, и своей стрелки на экране
 * быть не должно — их стало бы две. Но вне Telegram (браузер на компьютере, превью, стенд без
 * клиента) нативной кнопки нет вовсе, и вложенный экран вроде «Моих оплат» превращался в тупик:
 * выйти из него было нечем. Показывается только там, где нативная кнопка недоступна.
 */
export function BackBar({ onBack }: { onBack: () => void }) {
  return (
    <div
      className="px-4 pt-3"
      style={{ paddingTop: 'calc(var(--safe-top) + 0.75rem)' }}
    >
      <button
        type="button"
        onClick={onBack}
        aria-label={texts.common.back}
        className="pressable text-muted hover:text-fg -ml-1 flex h-11 items-center gap-1.5 px-1 text-base font-medium"
      >
        <svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
        {texts.common.back}
      </button>
    </div>
  );
}
